import { FORGOT_SUCCESS, LOGIN_SUCCESS } from '$gbusiness/redux/auth/types';
import { VALIDATE_INVOICE_SUCCESS } from '../invoice/types';

import { InitModel, LOAD_HEADERS, INIT_STATE, INIT_SUCCESS } from './types';

export function initReducer(state: InitModel = INIT_STATE, action): InitModel {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        headers: {
          ...state.headers,
        },
      };
    case INIT_SUCCESS:
      return {
        ...state,
        initSuccess: true,
      };
    case VALIDATE_INVOICE_SUCCESS:
      return {
        ...state,
      };
    case LOAD_HEADERS:
      return {
        ...state,
        headers: {
          ...state.headers,
          ...action.headers,
        },
      };
    case FORGOT_SUCCESS:
      return {
        ...state,
        public: {
          ...state.public,
          resetRequested: true,
        },
      };
    default:
      return state;
  }
}
